import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  page: string;
  limit: string;
  search: string;
  status?: string;
  subscriptionStatus?: string;
  billingStatus?: string;
  sortBy?: string;
  sortOrder?: string;
}

export const useGetKeyList = ({
  page,
  limit,
  search,
  status,
  subscriptionStatus,
  billingStatus,
  sortBy,
  sortOrder,
}: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.GET_KEY, {
      page,
      limit,
      search,
      status,
      subscription_status: subscriptionStatus,
      billing_status: billingStatus,
      sort_by: sortBy,
      sort_order: sortOrder,
    }],
    {
      retry: false, // Don't retry on failure
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      notifyOnChangeProps: [
        "data",
        "error",
        "refetch",
        "isRefetching",
        "isSuccess",
        "isLoading",
      ],
    }
  );
};
